import { render, staticRenderFns } from "./SelectedRabbit.vue?vue&type=template&id=39a7c181&"
import script from "./SelectedRabbit.vue?vue&type=script&lang=ts&"
export * from "./SelectedRabbit.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedRabbit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
